/**
* Project Name : cop-web-portal
* File Name : OnBoarding.vue
* Description : OnBoarding page for notice SCOP menus
* Date : 2023.09.01
*/
<template>
  <div class="onboarding_wrap" v-if="onBoardingShow">
    <div class="onboarding_con">
      <h3 v-html="onBoardingTitle"></h3>
      <ol>
        <li v-for="(item, idx) in messageItemList" :key="idx">
          <h4>{{ $t(`cop.onboarding.message.title.${item}`) }}</h4>
          <p v-html="$t(`cop.onboarding.message.content.${item}`)"></p>
        </li>
      </ol>
      <div class="button">
        <button type="button" class="btn btn-normal" @click="() => onBoardingShow = false">{{ $t('sdl.common.label.close') }}</button>
        <div class="fx_form" v-if="!hideDontShowAgain">
          <label><input type="checkbox" @change="dontShowAgain">{{ $t('cop.onboarding.message.dontShow') }}</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import SDLLocale from '@/mixin/SDLLocale';
import { SDLUtil } from '@/utils';

export default {
  data() {
    return {
      messageItemList: ['home', 'prjInfo', 'consoleMgmt', 'resourceMgmt', 'monitoring', 'support', 'favorite', 'noti', 'useInfo'],
      userInfo: null,
      userId: '',
      userName: '',
      onBoardingKey: '',
      exp: 365 * 50, // OO일 동안 창 열지 않기 (don't show again for OO days)
      onBoardingShow: false,
      hideDontShowAgain: false,
    };
  },
  computed: {
    ...mapGetters({ locale: 'getLocale', mainPath: 'getMainPath' }),
    onBoardingTitle() {
      return SDLUtil.getMsgProp('cop.onboarding.message.title.welcome', [this.userName]);
    },
  },
  watch: {
    locale() {
      this.changeUserName();
    },
    $route() {
      this.checkExpire();
    },
  },
  mixins: [SDLLocale],
  methods: {
    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: 컴포넌트 init (init component)
     * since: 2023.09.01
     */
    init() {
      this.userInfo = SDLUtil.getLoginedUserInfo();
      this.userId = this.userInfo.userId;
      this.onBoardingKey = `scopOnBoarding${this.userId}`;
      this.changeUserName();
    },
    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: "다시 보지 않기" 체크박스 ("don't show again" check box)
     * since: 2023.09.01
     */
    dontShowAgain() {
      if (!_.isEmpty(localStorage.getItem(this.onBoardingKey))) {
        localStorage.removeItem(this.onBoardingKey);
        return;
      }
      const expireDate = new Date().getTime() + this.exp * 24 * 60 * 60 * 1000;
      localStorage.setItem(this.onBoardingKey, expireDate);
    },
    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: "다시 보지 않기" 만료일시 체크 (check expiration of "don't show again")
     * since: 2023.09.01
     */
    checkExpire() {
      const mainYn = this.$route.path === this.mainPath;
      const expireDate = localStorage.getItem(this.onBoardingKey);
      const now = new Date().getTime();
      const isExpire = parseInt(expireDate, 10) < now;
      if (mainYn && (_.isEmpty(expireDate) || isExpire)) {
        this.onBoardingShow = true;
        this.hideDontShowAgain = false;
      }
    },
    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: Locale에 따라 user name 변경 (change user name by Locale)
     * since: 2023.09.01
     */
    changeUserName() {
      if (this.locale === 'ko_KR') this.userName = this.userInfo.userName;
      else if (this.locale === 'en_US') this.userName = this.userInfo.userNameEn;
    },
  },
  created() {
    this.init();
    this.checkExpire();
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/view/admin/main/OnBoarding.vue